'use client';
import React, { useState } from 'react';
import { ChevronRight, Globe } from 'lucide-react';

const regions = [
  { id: 'geo-na', region: 'North America', revenue: 1842300, share: 42.9, change: +14.2, flag: '🇺🇸' },
  { id: 'geo-eu', region: 'Europe', revenue: 1124800, share: 26.2, change: +8.7, flag: '🇪🇺' },
  { id: 'geo-apac', region: 'Asia Pacific', revenue: 718400, share: 16.8, change: +22.1, flag: '🌏' },
  { id: 'geo-latam', region: 'Latin America', revenue: 341200, share: 8.0, change: -3.4, flag: '🌎' },
  { id: 'geo-mena', region: 'Middle East & Africa', revenue: 260640, share: 6.1, change: +5.8, flag: '🌍' },
];

export default function GeoRevenuePanel() {
  const [selected, setSelected] = useState<string | null>(null);

  return (
    <div className="card-surface p-5">
      <div className="flex items-center justify-between mb-4">
        <div>
          <h2 className="text-base font-semibold text-foreground">Geographic Revenue</h2>
          <p className="text-sm text-muted-foreground">Revenue by region — May 2026</p>
        </div>
        <Globe size={18} className="text-muted-foreground" />
      </div>
      <div className="space-y-2.5">
        {regions?.map((r) => (
          <button
            key={r?.id}
            onClick={() => setSelected(selected === r?.id ? null : r?.id)}
            className={`w-full text-left rounded-lg p-3 transition-all duration-150 border ${
              selected === r?.id
                ? 'border-primary/40 bg-primary/5' :'border-transparent hover:bg-muted'
            }`}
          >
            <div className="flex items-center justify-between mb-1.5">
              <div className="flex items-center gap-2">
                <span className="text-base">{r?.flag}</span>
                <span className="text-sm font-medium text-foreground">{r?.region}</span>
              </div>
              <div className="flex items-center gap-2">
                <span className={`text-xs font-semibold ${r?.change >= 0 ? 'text-positive' : 'text-negative'}`}>
                  {r?.change >= 0 ? '+' : ''}{r?.change}%
                </span>
                <ChevronRight
                  size={12}
                  className={`text-muted-foreground transition-transform ${selected === r?.id ? 'rotate-90' : ''}`}
                />
              </div>
            </div>
            <div className="flex items-center gap-2">
              <div className="flex-1 h-1.5 bg-muted rounded-full overflow-hidden">
                <div
                  className="h-full bg-primary rounded-full transition-all duration-500"
                  style={{ width: `${r?.share}%` }}
                />
              </div>
              <span className="text-xs text-muted-foreground w-8 text-right">{r?.share}%</span>
            </div>
            {selected === r?.id && (
              <div className="mt-2 pt-2 border-t border-border">
                <p className="text-xs text-muted-foreground">
                  Total Revenue:{' '}
                  <span className="font-semibold text-foreground">
                    ${r?.revenue?.toLocaleString()}
                  </span>
                </p>
              </div>
            )}
          </button>
        ))}
      </div>
    </div>
  );
}